import { mode } from '@chakra-ui/theme-tools';

export const tagColorVariables = {
	COLLABORATION_OPTIMISTIC_BG: '#01B5741A',
	COLLABORATION_PESSIMISTIC_BG: '#B01A2E1A',
	COLLABORATION_MODERATE_BG: '#BB92001A',
	COLLABORATION_UNIFORM_BG: '#3148661A',
	COLLABORATION_NONE_BG: '#5050501A',
	COLLABORATION_TEXT_OPTIMISTIC: '#01B574',
	COLLABORATION_TEXT_PESSIMISTIC: '#B01A2E',
	COLLABORATION_TEXT_MODERATE: '#BB9200',
	COLLABORATION_TEXT_UNIFORM: '#314866',
	COLLABORATION_TEXT_NONE: '#505050',
};

export const globalStyles = {
	colors: {
		modalHeader: {
			bg: {
				light: 'whiteAlpha.500',
				dark: 'rgba(11,20,55,0.5)',
			},
		},
		brand: {
			100: '#E9E3FF',
			200: '#422AFB',
			300: '#422AFB',
			400: '#7551FF',
			500: '#422AFB',
			600: '#3311DB',
			700: '#02044A',
			800: '#190793',
			900: '#11047A',
		},
		easyBrandMenu: {
			100: '#FFFFFF',
			200: '#E9EDF7',
		},
		easyRED: {
			100: '#F0243E1A',
			150: '#ffe9ec',
			175: '#FC8181',
			200: '#FC6574',
			300: '#F0243E', //easyred-figma
			400: '#B01A2E',
			450: '#B22829',
			500: '#B30000',
		},
		easyBLUE: {
			100: '#F1F3F9', //bg menu
			150: '#A3AED0',
			175: '#C2C9E1',
			180: '#B1BBDD',
			200: '#567EB3',
			300: '#314866', //easyblue-figma
			350: '#31486633', //easyblue-figma-alpha-channel
			400: '#25364D',
			500: '#055A7F',
			600: '#0789C2',
			700: '#0296F2',
		},
		brandScheme: {
			100: '#E9E3FF',
			200: '#7551FF',
			300: '#7551FF',
			400: '#7551FF',
			500: '#422AFB',
			600: '#3311DB',
			700: '#02044A',
			800: '#190793',
			900: '#02044A',
		},
		secondaryGray: {
			100: '#E0E5F2',
			150: '#E2E8F0',
			175: '#E1E8EF',
			200: '#E1E9F8',
			250: '#FAFAFA',
			300: '#F4F7FE',
			400: '#E9EDF7',
			500: '#8F9BBA',
			600: '#A3AED0',
			700: '#707EAE',
			800: '#707EAE',
			900: '#1B2559',
		},
		red: {
			100: '#FEEFEE',
			500: '#EE5D50',
			600: '#E31A1A',
		},
		blue: {
			50: '#EFF4FB',
			500: '#3965FF',
			600: '#007bff',
			alpha: 'rgba(0, 123, 255, 0.1)',
		},
		orange: {
			100: '#FFF6DA',
			500: '#FFB547',
			600: '#FDAB31',
			700: '#9C4221',
		},
		green: {
			100: '#E6FAF5',
			200: '#1BA118',
			500: '#01B574',
		},
		navy: {
			50: '#d0dcfb',
			100: '#aac0fe',
			200: '#a3b9f8',
			300: '#728fea',
			400: '#3652ba',
			500: '#1b3bbb',
			600: '#24388a',
			700: '#1B254B',
			800: '#111c44',
			900: '#0b1437',
		},
		gray: {
			100: '#FAFCFE',
			250: '#505050',
		},
		statisticsColors: {
			textSecondary: '#4A5568',
			textTertiary: '#2D3748',
			textMuted: '#6b7280',
			bgLight: '#f5f5f5',
			blueTooltip: '#2C5282',
			orangeFuture: '#f97316',
			redError: '#dc2626',
			redAlert: '#E53E3E',
			blueLight: '#63b3ed',
			panelText: '#333',
		},
		graphic: {
			red: '#F0243E',
			lightRed: '#FC6574',
			darkBlue: '#3965FF',
			blue: '#314866',
			lightBlue: '#ff6d00',
			turquoise: '#49A1B2',
			gray: '#A3AED0',
			green: '#00E396',
			pastelGreen: '#B0E57C',
			yellow: '#FFB547',
			orange: '#ff6d00',
			purple: '#713C81',
			lightPurple: '#9F79EE',
		},
		tables: {
			color: {
				hover: '#42adef',
			},
			background: {
				level0: '#f6f6f8',
				hover: '#f4f7fe',
				total: '#E9EDF7',
				media: '#F4F7FE',
				fatMeta: '#F4F7FE',
				fatBoaMeta: '#F4F7FE',
				fcstMeta: '#F4F7FE',
				fatBoaFcst: '#F4F7FE',
				crescimento: '#E0E5F2',
				fatHistorico: '#F4F7FE',
				fatRestrito: '#F4F7FE',
				fatBoaHistorico: '#F4F7FE',
				fatBoaRestrito: '#F4F7FE',
			},
		},
		modal: {
			overlay: 'rgba(0, 0, 0, 0.5)',
			hoverButton: '#f0f0f0',
			shakeBorder: '#808080',
			shakeShadow: 'rgba(59, 59, 59, 0.3)',
		},
		easy360: {
			bgWhite: '#fff',
			bgCard: '#fcfbf9',
			border: '#e2e8f0',
			borderLight: '#f7fafc',
			shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
			hover: '#f7fafc',
			gradients: {
				red: 'linear-gradient(0deg, rgba(178, 40, 41, 1) 0%, rgba(255, 55, 58, 1) 100%)',
			},
		},
		loader360: {
			gradientStart: '#008aff',
			gradientEnd: '#ff0000',
			solid: '#314866',
		},
		comparativeSummary: {
			lastYear: '#a3aed0', // Light Purple - Faturamento Ano Anterior
			budget: '#f0243e', // Red - Orçamento
			planning: '#314866', // Dark Blue para Irrestrito, Green para Restrito
			percentage: '#b01a2e', // Orange para linha de percentual
			planningVsBudget: '#f0243e', // Red - Plano x Orçamento
			planningVsLastYear: '#808080', // Gray - Plano x Fat. Ano Anterior
		},
	},
	styles: {
		global: props => ({
			body: {
				overflowX: 'hidden',
				bg: mode('#fdfeff', 'navy.900')(props),
				fontFamily: 'DM Sans',
				letterSpacing: '-0.5px',
			},
			input: {
				color: 'gray.700',
			},
			html: {
				fontFamily: 'DM Sans',
			},
		}),
	},
};
